import { render, staticRenderFns } from "./SewageTreatmentWriteBody.vue?vue&type=template&id=1f0f002c&scoped=true"
import script from "./SewageTreatmentWriteBody.vue?vue&type=script&lang=js"
export * from "./SewageTreatmentWriteBody.vue?vue&type=script&lang=js"
import style0 from "./SewageTreatmentWriteBody.vue?vue&type=style&index=0&id=1f0f002c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f002c",
  null
  
)

export default component.exports